var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFaq = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 67,
    viewBox: "0 0 65 67",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#89B6DE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.8,
    d: "M10.612 53.356c-11.87-10.448-13.76-28.246-4.35-40.954C15.672-.306 33.248-3.69 46.703 4.617 60.16 12.923 65.012 30.15 57.87 44.259c-7.144 14.108-23.901 20.394-38.561 14.465M36.54 7.264c7.415 1.855 13.49 7.152 16.34 14.244M19.008 58.764L14.692 61.152 10.376 63.544 10.464 58.612 10.552 53.68"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#89B6DE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.8,
    d: "M19.548 23.512c-.002-3.644 2.193-6.93 5.559-8.326 3.366-1.395 7.242-.624 9.819 1.952 2.576 2.577 3.347 6.453 1.952 9.82-1.396 3.365-4.682 5.56-8.326 5.558V41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.536,
    cy: 47.14,
    r: 1.432,
    fill: "#89B6DE",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFaq, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/faq.a963e807.svg";
export { ForwardRef as ReactComponent };